import React, {Fragment, useState} from "react";
import {translate} from 'react-i18next';
import {
  changeUpgradeDsdCubesSelectedCubes,
  downloadUpgradeDsdDsdsCompareReport,
  hideUpgradeDsdCodelistCompareReport,
  hideUpgradeDsdCubes,
  hideUpgradeDsdDsdsCompareReport,
  hideUpgradeDsdDsdUpgrade,
  hideUpgradeDsdImportDsd,
  hideUpgradeDsdImportDsdReport,
  hideUpgradeDsdUpgradedDsds,
  readUpgradeDsdCodelistCompareReport,
  readUpgradeDsdCubes,
  readUpgradeDsdUpgradedDsds,
  setUpgradeDsdImportDsdFile,
  showUpgradeDsdDsdUpgrade,
  showUpgradeDsdImportDsd,
  startUpgradeDsdImportDsdImport,
  submitUpgradeDsdDsdsCompare,
  submitUpgradeDsdDsdUpgrade,
  submitUpgradeDsdImportDsdDsdsCompare,
  submitUpgradeDsdImportDsdFile,
  uploadUpgradeDsdImportDsdFile
} from "./actions";
import {connect} from "react-redux";
import {compose} from "redux";
import {Alert, Button, Col, Form, Icon, Input, Modal, Row} from "antd";
import {
  GUTTER_MD,
  GUTTER_SM,
  MARGIN_MD,
  MODAL_WIDTH_LG,
  MODAL_WIDTH_MD,
  SPAN_ONE_THIRD,
  SPAN_TWO_THIRDS,
  TABLE_COL_MIN_WIDTH_ID,
  TABLE_COL_MIN_WIDTH_NAME
} from "../../../styles/constants";
import EnhancedModal from "../../../components/enhanced-modal";
import Call from "../../../hocs/call";
import {BUTTON_DSD_COMPARE, BUTTON_DSD_UPGRADE} from "../../../styles/buttons";
import {getArtefactTripletFromUrn, getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import DsdsCompareReport from "../../../components/dsds-compare-report";
import {DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX} from "./reducer";
import {reuseAction} from "../../../utils/reduxReuse";
import {showCodelistDetail} from "../../../redux-components/redux-codelist-detail-modal/actions";
import InfiniteScrollTable from "../../../components/infinite-scroll-table";
import FileInput from "../../../components/file-input";
import ReportCard from "./reportCard";

const IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS = "Success";
const IMPORT_STRUCTURES_REPORT_STATUS_WARNING = "Warning";
const IMPORT_STRUCTURES_REPORT_STATUS_ERROR = "Error";
const IMPORT_STRUCTURES_REPORT_STATUS_FAILURE = "Failure";

const mapStateToProps = state => ({
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  appLanguage: state.app.language,
  sourceDsdTriplet: state.scenes.dataManager.upgradeDsd.sourceDsdTriplet,
  cubes: state.scenes.dataManager.upgradeDsd.cubes,
  selectedCubes: state.scenes.dataManager.upgradeDsd.selectedCubes,
  cubesToUpgrade: state.scenes.dataManager.upgradeDsd.cubesToUpgrade,
  isUpgradedDsdsVisible: state.scenes.dataManager.upgradeDsd.isUpgradedDsdsVisible,
  targetDsdTriplet: state.scenes.dataManager.upgradeDsd.targetDsdTriplet,
  upgradedDsds: state.scenes.dataManager.upgradeDsd.upgradedDsds,
  isCompareReportVisible: state.scenes.dataManager.upgradeDsd.isCompareReportVisible,
  compareReport: state.scenes.dataManager.upgradeDsd.compareReport,
  isUpgradeVisible: state.scenes.dataManager.upgradeDsd.isUpgradeVisible,
  upgradeReport: state.scenes.dataManager.upgradeDsd.upgradeReport,
  codelistCompareReport: state.scenes.dataManager.upgradeDsd.codelistCompareReport,
  codelistDetail: state.scenes.dataManager.upgradeDsd.codelistDetail,
  isImportDsdVisible: state.scenes.dataManager.upgradeDsd.isImportDsdVisible,
  dsdFile: state.scenes.dataManager.upgradeDsd.dsdFile,
  isImportEnabled: state.scenes.dataManager.upgradeDsd.isImportEnabled,
  importDsdHash: state.scenes.dataManager.upgradeDsd.importDsdHash,
  importDsdItems: state.scenes.dataManager.upgradeDsd.importDsdItems,
  importDsdReport: state.scenes.dataManager.upgradeDsd.importDsdReport,
});

const mapDispatchToProps = dispatch => ({
  fetchCubes: (sourceDsdTriplet, targetDsdTriplet) => dispatch(readUpgradeDsdCubes(sourceDsdTriplet, targetDsdTriplet)),
  onCubesHide: () => dispatch(hideUpgradeDsdCubes()),
  onSelectedCubesChange: selectedCubes => dispatch(changeUpgradeDsdCubesSelectedCubes(selectedCubes)),
  fetchUpgradedDsds: ({dsdTriplet, cubes}) => dispatch(readUpgradeDsdUpgradedDsds(dsdTriplet, cubes)),
  onUpgradedDsdsHide: () => dispatch(hideUpgradeDsdUpgradedDsds()),
  onDsdsCompareSubmit: ({sourceDsdTriplet, targetDsdTriplet, showModal}) =>
    dispatch(submitUpgradeDsdDsdsCompare(sourceDsdTriplet, targetDsdTriplet, showModal)),
  onDsdsCompareHide: () => dispatch(hideUpgradeDsdDsdsCompareReport()),
  onDsdUpgradeShow: cubes => dispatch(showUpgradeDsdDsdUpgrade(cubes)),
  onDsdUpgradeSubmit: ({report, cubes}) => dispatch(submitUpgradeDsdDsdUpgrade(report, cubes)),
  onDsdUpgradeHide: success => dispatch(hideUpgradeDsdDsdUpgrade(success)),
  fetchCodelistCompareReport: (sourceCodelistTriplet, targetCodelistTriplet, _, targetFile) =>
    dispatch(readUpgradeDsdCodelistCompareReport(sourceCodelistTriplet, targetCodelistTriplet, targetFile)),
  onCodelistCompareReportHide: () => dispatch(hideUpgradeDsdCodelistCompareReport()),
  onCodelistDetailShow: (codelistTriplet, defaultItemsViewMode) =>
    dispatch(reuseAction(showCodelistDetail(codelistTriplet, defaultItemsViewMode), DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX)),
  onImportDsdShow: () => dispatch(showUpgradeDsdImportDsd()),
  onImportDsdHide: () => dispatch(hideUpgradeDsdImportDsd()),
  onFileSet: file => dispatch(setUpgradeDsdImportDsdFile(file)),
  onDsdImportDsdsCompare: ({sourceDsdTriplet, dsdFile, showModal}) =>
    dispatch(submitUpgradeDsdImportDsdDsdsCompare(sourceDsdTriplet, dsdFile, showModal)),
  onDsdsCompareDownload: (srcTriplet, targetTriplet, targetFile, lang) =>
    dispatch(downloadUpgradeDsdDsdsCompareReport(srcTriplet, targetTriplet, targetFile, lang)),
  onImportDsdStart: () => dispatch(startUpgradeDsdImportDsdImport()),
  onImportDsdFileUpload: file => dispatch(uploadUpgradeDsdImportDsdFile(file)),
  onImportDsdFileSubmit: ({importDsdItems, importDsdHash}) => dispatch(submitUpgradeDsdImportDsdFile(importDsdItems, importDsdHash)),
  onImportDsdImportHide: () => dispatch(hideUpgradeDsdImportDsdReport()),
});


const UpgradedDsdList = ({
                           t,
                           nodeId,
                           nodes,
                           appLanguage,
                           sourceDsdTriplet,
                           cubes,
                           selectedCubes,
                           cubesToUpgrade,
                           isUpgradedDsdsVisible,
                           targetDsdTriplet,
                           upgradedDsds,
                           isCompareReportVisible,
                           compareReport,
                           isUpgradeVisible,
                           upgradeReport,
                           codelistCompareReport,
                           codelistDetail,
                           isImportDsdVisible,
                           dsdFile,
                           isImportEnabled,
                           importDsdHash,
                           importDsdItems,
                           importDsdReport,
                           fetchCubes,
                           onSelectedCubesChange,
                           onCubesHide,
                           fetchUpgradedDsds,
                           onUpgradedDsdsHide,
                           onDsdsCompareSubmit,
                           onDsdsCompareHide,
                           onDsdUpgradeShow,
                           onDsdUpgradeSubmit,
                           onDsdUpgradeHide,
                           fetchCodelistCompareReport,
                           onCodelistCompareReportHide,
                           onCodelistDetailShow,
                           onImportDsdShow,
                           onImportDsdHide,
                           onFileSet,
                           onDsdImportDsdsCompare,
                           onDsdsCompareDownload,
                           onImportDsdStart,
                           onImportDsdFileUpload,
                           onImportDsdFileSubmit,
                           onImportDsdImportHide
                         }) => {

  const [isWarningInfoVisible, setWarningInfoVisibility] = useState(false);

  const defaultItemsViewMode = nodes.find(node => node.general.id === nodeId).general.defaultItemsViewMode;
  const importDsdSelectedItems = (importDsdItems || []).filter(({isOk}) => isOk);

  return (
    <Fragment>

      {/*upgradedDsds*/}
      <Call
        cb={fetchUpgradedDsds}
        cbParam={{
          dsdTriplet: sourceDsdTriplet,
          cubes: cubesToUpgrade
        }}
        disabled={!sourceDsdTriplet || upgradedDsds !== null}
      >
        <EnhancedModal
          visible={isUpgradedDsdsVisible}
          onCancel={onUpgradedDsdsHide}
          title={t('scenes.dataManager.upgradeDsd.modals.upgradedDsdList.title', {
            triplet: sourceDsdTriplet ? getStringFromArtefactTriplet(sourceDsdTriplet) : ""
          })}
          withDataLanguageSelector
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={onUpgradedDsdsHide}>{t('commons.buttons.close.title')}</Button>}
        >
          <InfiniteScrollTable
            data={upgradedDsds || []}
            getRowKey={({id, agency, version}) => `${id}+${agency}+${version}`}
            columns={[
              {
                title: t('data.artefact.id.shortLabel'),
                dataIndex: 'id',
                minWidth: TABLE_COL_MIN_WIDTH_ID
              },
              {
                title: t('data.artefact.agencyID.shortLabel'),
                dataIndex: 'agency',
                widthToContent: true,
                withValuesFilter: true
              },
              {
                title: t('data.artefact.name.shortLabel'),
                dataIndex: 'names',
                minWidth: TABLE_COL_MIN_WIDTH_NAME
              },
              {
                title: t('data.artefact.version.shortLabel'),
                dataIndex: 'version',
                widthToContent: true,
                withValuesFilter: true
              },
              {
                title: t('data.artefact.isFinal.shortLabel'),
                dataIndex: "isFinal",
                width: 30,
                withValuesFilter: true,
                render: isFinal => isFinal
                  ? <Icon type="check"/>
                  : null,
                renderText: isFinal => isFinal
                  ? t('data.artefact.isFinal.values.final')
                  : t('data.artefact.isFinal.values.notFinal'),
              }
            ]}
            multilangStrDataIndexes={["names"]}
            actions={[
              {
                ...BUTTON_DSD_COMPARE,
                title: t('commons.actions.compareDsds.title'),
                onClick: ({id, agency, version}) => onDsdsCompareSubmit({
                  sourceDsdTriplet,
                  targetDsdTriplet: {id, agencyID: agency, version},
                  showModal: true
                })
              },
              {
                ...BUTTON_DSD_UPGRADE,
                title: t('commons.actions.upgradeDsd.title'),
                onClick: ({id, agency, version}) => fetchCubes(sourceDsdTriplet, {id, agencyID: agency, version})
              }
            ]}
            rightActions={
              <Button
                type="primary"
                onClick={onImportDsdShow}
              >
                {t('scenes.dataManager.upgradeDsd.modals.upgradedDsdList.buttons.import.title')}
              </Button>
            }
          />
        </EnhancedModal>
      </Call>

      {/*import form*/}
      <EnhancedModal
        visible={isImportDsdVisible}
        onCancel={onImportDsdHide}
        title={t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.title')}
        withDataLanguageSelector
        width={MODAL_WIDTH_MD}
        footer={
          <div>
            <Button onClick={onImportDsdHide}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button type="primary" onClick={onImportDsdStart} disabled={!dsdFile}>
              {t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.importDsdInMsdb.title')}
            </Button>
          </div>
        }
      >
        <Fragment>
          <Row style={{marginBottom: MARGIN_MD}}>
            <Form.Item
              label={t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.dsd.label')}
              className="form-item-required"
              labelCol={{span: SPAN_ONE_THIRD}}
              wrapperCol={{span: SPAN_TWO_THIRDS}}
            >
              <FileInput
                value={dsdFile}
                accept={'.xml'}
                onChange={file => onFileSet(file)}
              />
            </Form.Item>
          </Row>
          <Row type="flex" justify="end" gutter={GUTTER_SM} style={{marginBottom: MARGIN_MD}}>
            <Col>
              <Button
                type="primary"
                onClick={() => onDsdImportDsdsCompare({sourceDsdTriplet, dsdFile, showModal: true})}
                disabled={!dsdFile}
              >
                {t('scenes.dataManager.upgradeDsd.modals.importDsdFromFile.compareDsds.title')}
              </Button>
            </Col>
          </Row>
        </Fragment>
      </EnhancedModal>

      {/*compare report*/}
      <EnhancedModal
        visible={isCompareReportVisible}
        onCancel={onDsdsCompareHide}
        title={t('scenes.dataManager.upgradeDsd.modals.compareDsdsReport.title')}
        withDataLanguageSelector
        width={MODAL_WIDTH_LG}
        footer={
          <div>
            <Button onClick={onDsdsCompareHide}>{t('commons.buttons.close.title')}</Button>
            <Button
              type="primary"
              onClick={() => onDsdsCompareDownload(sourceDsdTriplet, targetDsdTriplet, dsdFile, appLanguage)}
            >
              {t('commons.buttons.download.title')}
            </Button>
          </div>
        }
      >
        {compareReport && compareReport.compare === false && (
          <Alert
            type="warning"
            showIcon
            message={
              <Row type="flex" align="middle" gutter={GUTTER_SM}>
                <Col>
                  {t('scenes.dataManager.upgradeDsd.modals.compareDsdsReport.incompatibleDsds.title')}
                </Col>
                <Col>
                  <Button shape="circle" size="small" icon="info" onClick={() => setWarningInfoVisibility(true)}/>
                </Col>
              </Row>
            }
          />
        )}
        <Row type="flex" justify="space-between" style={{marginBottom: MARGIN_MD}}>
          <Col span={10}>
            <Input
              value={compareReport ? compareReport.sourceDsd : ''}
              title={compareReport ? compareReport.sourceDsd : ''}
              disabled
            />
          </Col>
          <Col span={10}>
            <Input
              value={compareReport ? compareReport.targetDsd : ''}
              title={compareReport ? compareReport.targetDsd : ''}
              disabled
            />
          </Col>
        </Row>
        <DsdsCompareReport
          report={compareReport}
          codelistDetail={codelistDetail}
          codelistDetailInstancePrefix={DM_UPGRADE_DSD_CODELIST_DETAIL_PREFIX}
          onCodelistDetailShow={triplet => onCodelistDetailShow(triplet, defaultItemsViewMode)}
          codelistCompareReport={codelistCompareReport}
          fetchCodelistCompareReport={fetchCodelistCompareReport}
          onCodelistCompareReportHide={onCodelistCompareReportHide}
          panelStyle={{maxHeight: 400}}
        />
        <EnhancedModal
          visible={isWarningInfoVisible}
          onCancel={() => setWarningInfoVisibility(false)}
          title={t('scenes.dataManager.upgradeDsd.modals.cannotUpgradeDsd.title')}
          width={540}
          footer={<Button onClick={() => setWarningInfoVisibility(false)}>{t('commons.buttons.close.title')}</Button>}
        >
          <span style={{whiteSpace: "pre-line"}}>
            {t('errors.businessLogic.UPGRADECUBE_NOTCOMPATIBLE')}
          </span>
        </EnhancedModal>
      </EnhancedModal>

      {/*select cubes*/}
      <EnhancedModal
        visible={cubes !== null}
        onCancel={onCubesHide}
        title={t('scenes.dataManager.upgradeDsd.modals.cubeList.title')}
        withDataLanguageSelector
        width={MODAL_WIDTH_LG}
        footer={
          <Fragment>
            <Button onClick={onCubesHide}>
              {t('commons.buttons.close.title')}
            </Button>
            <Button
              type="primary"
              onClick={() => Modal.confirm({
                title: t('scenes.dataManager.upgradeDsd.modals.cubeList.confirmModals.title', {
                  triplet: getStringFromArtefactTriplet(targetDsdTriplet)
                }),
                onOk() {
                  onDsdUpgradeShow(selectedCubes);
                },
                cancelText: t('commons.buttons.cancel.title')
              })}
              disabled={(selectedCubes || []).length === 0}
            >
              {t('commons.buttons.confirm.title')}
            </Button>
          </Fragment>
        }
      >
        <InfiniteScrollTable
          data={cubes}
          getRowKey={cube => cube.IDCube}
          multilangStrDataIndexes={['labels']}
          columns={[
            {
              title: t('data.cube.id.label'),
              dataIndex: 'Code',
              minWidth: TABLE_COL_MIN_WIDTH_ID
            },
            {
              title: t('data.cube.name.label'),
              dataIndex: 'labels',
              minWidth: TABLE_COL_MIN_WIDTH_NAME
            }
          ]}
          rowSelection={{
            selectedRowKeys: selectedCubes || [],
            onChange: onSelectedCubesChange
          }}
        />
      </EnhancedModal>

      {/*compare and upgrade*/}
      <Call
        cb={onDsdsCompareSubmit}
        cbParam={{sourceDsdTriplet, targetDsdTriplet, cubes: cubesToUpgrade, showModal: false}}
        disabled={!sourceDsdTriplet || !targetDsdTriplet || !cubesToUpgrade || isUpgradeVisible === false}
      >
        {
          compareReport && isUpgradeVisible === true && (
            compareReport.compare === false
              ? (
                <Call
                  cb={() => Modal.warning({
                    title: t('scenes.dataManager.upgradeDsd.modals.cannotUpgradeDsd.title'),
                    content: (
                      <span style={{whiteSpace: "pre-line"}}>
                        {t('errors.businessLogic.UPGRADECUBE_NOTCOMPATIBLE')}
                      </span>
                    ),
                    width: 540,
                    onOk() {
                      onDsdUpgradeHide(false)
                    },
                    onCancel() {
                      onDsdUpgradeHide(false)
                    }
                  })}
                >
                  <span/>
                </Call>
              )
              : (
                <Call
                  cb={onDsdUpgradeSubmit}
                  cbParam={{
                    report: compareReport,
                    cubes: cubesToUpgrade
                  }}
                >
                  <EnhancedModal
                    visible={upgradeReport !== null}
                    onCancel={() => onDsdUpgradeHide(true)}
                    width={MODAL_WIDTH_LG}
                    title={t('scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.title')}
                    withDataLanguageSelector
                    footer={
                      <div>
                        <Button onClick={() => onDsdUpgradeHide(true)}>{t('commons.buttons.close.title')}</Button>
                        <Button
                          type="primary"
                          onClick={() => onDsdsCompareDownload(sourceDsdTriplet, targetDsdTriplet, dsdFile, appLanguage)}
                        >
                          {t('commons.buttons.download.title')}
                        </Button>
                      </div>
                    }
                  >
                    <Row type="flex" gutter={GUTTER_MD}>
                      <ReportCard type="success" name="upgrade"/>
                      <ReportCard type="warning" name="reCreated"/>
                      <ReportCard
                        type="warning"
                        name="notChanged"
                        message={t('scenes.dataManager.upgradeDsd.modals.upgradeDsdReport.notChanged.message')}
                      />
                      <ReportCard type="error" name="fail"/>
                      <ReportCard type="warning" name="categorizationFail"/>
                    </Row>
                  </EnhancedModal>
                </Call>
              )
          )
        }
      </Call>

      {/*compare and import*/}
      <Call
        cb={onDsdImportDsdsCompare}
        cbParam={{sourceDsdTriplet, dsdFile, showModal: false}}
        disabled={!sourceDsdTriplet || !dsdFile || isImportEnabled === false}
      >
        {
          compareReport && isImportEnabled === true && (
            compareReport.compare === false
              ? (
                <Call
                  cb={() => Modal.warning({
                    title: t('scenes.dataManager.upgradeDsd.modals.cannotUpgradeDsd.title'),
                    content: (
                      <span style={{whiteSpace: "pre-line"}}>
                        {t('errors.businessLogic.UPGRADECUBE_NOTCOMPATIBLE')}
                      </span>
                    ),
                    width: 540,
                    onOk() {
                      onImportDsdImportHide()
                    },
                    onCancel() {
                      onImportDsdImportHide()
                    }
                  })}
                >
                  <span/>
                </Call>
              )
              : (
                <Call
                  cb={onImportDsdFileUpload}
                  cbParam={dsdFile}
                  disabled={!dsdFile || !!importDsdItems || !!importDsdHash}
                >
                  <Call
                    cb={onImportDsdFileSubmit}
                    cbParam={{
                      importDsdItems: importDsdSelectedItems,
                      importDsdHash
                    }}
                    disabled={!importDsdItems || !importDsdHash}
                  >
                    <EnhancedModal
                      visible={importDsdReport !== null}
                      onCancel={onImportDsdImportHide}
                      title={t('scenes.dataManager.upgradeDsd.modals.importDsdReport.title')}
                      footer={<Button onClick={onImportDsdImportHide}>{t('commons.buttons.close.title')}</Button>}
                    >
                      {
                        (importDsdSelectedItems && importDsdSelectedItems.length > 0 && importDsdReport)
                          ? (
                            importDsdReport.map(({maintainableObject, status, result, isFinal}, index) => {
                              const triplet = getArtefactTripletFromUrn(maintainableObject);
                              return (
                                <Fragment key={index}>
                                  <Row type="flex" justify="space-between"
                                       style={index > 0 ? {marginTop: MARGIN_MD} : null}>
                                    <Col>
                                      {importDsdItems.filter(item =>
                                        item.id === triplet.id && item.agency === triplet.agencyID && item.version === triplet.version
                                      )[0].type} [{getStringFromArtefactTriplet(triplet)}] <b>
                                      {(isFinal
                                          ? t("data.artefact.isFinal.values.final")
                                          : t("data.artefact.isFinal.values.notFinal")
                                      ).toLowerCase()}</b>
                                    </Col>
                                    <Col>
                                      {status === IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS && (
                                        <Fragment>
                                          {`${t('scenes.utilities.importStructures.reportModal.status.success')} `}
                                          <Icon type="check-circle" theme="filled"
                                                style={{color: 'green'}}/>
                                        </Fragment>
                                      )}
                                      {status === IMPORT_STRUCTURES_REPORT_STATUS_WARNING && (
                                        <Fragment>
                                          {`${t('scenes.utilities.importStructures.reportModal.status.warning')} `}
                                          <Icon type="exclamation-circle" theme="filled" style={{color: 'orange'}}/>
                                        </Fragment>
                                      )}
                                      {status === IMPORT_STRUCTURES_REPORT_STATUS_ERROR && (
                                        <Fragment>
                                          {`${t('scenes.utilities.importStructures.reportModal.status.error')} `}
                                          <Icon type="close-circle" theme="filled" style={{color: 'red'}}/>
                                        </Fragment>
                                      )}
                                      {status === IMPORT_STRUCTURES_REPORT_STATUS_FAILURE && (
                                        <Fragment>
                                          {`${t('scenes.utilities.importStructures.reportModal.status.error')} `}
                                          <Icon type="close-circle" theme="filled" style={{color: 'red'}}/>
                                        </Fragment>
                                      )}
                                    </Col>
                                  </Row>
                                  {status !== IMPORT_STRUCTURES_REPORT_STATUS_SUCCESS && (
                                    <i>{result}</i>
                                  )}
                                </Fragment>
                              );
                            })
                          )
                          :
                          <span>{t("scenes.dataManager.upgradeDsd.modals.importDsdReport.nothingImported.placeholder")}</span>
                      }
                    </EnhancedModal>
                  </Call>
                </Call>
              )
          )
        }
      </Call>

    </Fragment>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(UpgradedDsdList);